
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-411485fe&scoped=true!sass-loader?sourceMap!./app-footer.css")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./app-footer.vue"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-411485fe!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./app-footer.vue"),
  /* scopeId */
  "data-v-411485fe",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/layout/app-footer.vue
// module id = 1889
// module chunks = 1